/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import Logger from "../../../clients/logger";
import { BootTaskCallbackInterface } from "../types";
import { System } from "../../../common/system";

/**
 * Boot task that intializes the handlers for System Manaager API (see common/systemManagerClient)
 * @private
 */
export class InitializeDeepLinkingTask {
	public start(doneCallback: BootTaskCallbackInterface) {
		System.getProtocolString().then((data) => {
			Logger.system.log(`initializeDeepLinkingTask startup ${data}`);
		});
		doneCallback("initializeDeepLinkingTask", "bootTasks", "completed");
	}
}
